import axios from 'axios';
import { COST_CENTERS_EMPLOYEES } from 'RestAPIs/endpoints';
import { EmployeeDutyData } from './types';

export const getEmployeesBasedOnCostCenters = ({
  costCenters,
  startDate,
  endDate
}) =>
  axios.get<EmployeeDutyData[]>(COST_CENTERS_EMPLOYEES, {
    params: {
      costCenters,
      startDate,
      endDate
    }
  });
